const psw_regex = /[a-zA-Z0-9]{8,}/;
const email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const first_name_regex = /[a-zA-Z0-9]{1,}/;
const last_name_regex = /[a-zA-Z0-9]{2,}/;

export { psw_regex, email_regex, first_name_regex, last_name_regex };
